import React from 'react'
import { Divider } from 'antd'
import CommentDetail from './CommentDetail'

export default function EventComments ({ event, comments, addComment }) {
  return (
    <>
      {comments && comments.map((comment) => (
        <div key={comment.id}>
          <CommentDetail eventId={event.id} comment={comment} action="update" />
        </div>
      ))}
      <Divider />
      <div key={`new-comment-${event.id}-${comments.length + 1}`}>
        <CommentDetail eventId={event.id} action="new" comment={{ content_trix_html: '' }} addComment={addComment(comments)} />
      </div>
    </>
  )
}
